import Vue from "vue";
import VueRouter from "vue-router";
import user from "../services/user";

// ===========================================
//  Main Component (Load when this App load)
// ===========================================
import Home from "../views/Home.vue";
import ProductsList from "../views/ProductsList.vue";
import ProductView from "../views/ProductView.vue";
import Authen from "../views/Authen/Authen.vue";

// ===========================================
//                No Login
// ===========================================
const StoreList = () => import("../views/StoreList.vue");
const StoreView = () => import("../views/StoreView.vue");
const Manual = () => import("../views/Manual.vue");
const AboutUs = () => import("../views/AboutUs.vue");
const TermsAndConditions = () => import("../views/TermsAndConditions.vue");
const PrivacyAndPolicy = () => import("../views/PrivacyAndPolicy.vue");

const ContactAndConsult = () => import("../views/ContactAndConsult.vue");
const Notfound = () => import("../views/Notfound.vue");
// const PetExpress = () => import("../views/PetExpress.vue");

// ===========================================
//                  User
// ===========================================
const MyAccount = () => import("../views/User/MyAccount.vue");
// const CheckOut = () => import("../views/CheckOut.vue");

// ===========================================
//                  Store
// ===========================================
const CreateStore = () => import("../views/Store/CreateStore.vue");
const Store = () => import("../views/Store/Store.vue");
const MyStore = () => import("../views/Store/MyStore.vue");
const ProductManagement = () => import("../views/Store/ProductManagement.vue");
// const CreateProduct = () => import("../views/Store/CreateProduct.vue");

// ===========================================
//                  Admin
// ===========================================
const Admin = () => import("../views/Admin/AdminView.vue");
const AdminApproval = () => import("../views/Admin/ApprovalList.vue");
const AdminUserManager = () => import("../views/Admin/UserManagement.vue");
const AdminWebSetting = () => import("../views/Admin/WebSetting.vue");
const AdminHome = () => import("../views/Admin/Home.vue");
const AdminLogs = () => import("../views/Admin/Logs.vue");

Vue.use(VueRouter);

let routes = [
	{
		path: '/',
		name: "Home",
		component: Home
	}, {
		path: "/terms-and-conditions",
		name: "TermsAndConditions",
		component: TermsAndConditions
	}, {
		path: "/privacy-policy",
		name: "PrivacyPolicy",
		component: PrivacyAndPolicy
	}, {
		path: "/contact",
		name: "ContactAndConsult",
		component: ContactAndConsult
	}, {
		path: "/manual",
		name: "Manual",
		component: Manual
	}, {
		path: '/aboutUs',
		name: "aboutUs",
		component: AboutUs
	}, {
		path: '*',
		name: "Notfound",
		component: Notfound
	},
];

const routes_user = [
	{
		path: "/login",
		name: "Login",
		component: Authen
	}, {
		path: "/register",
		name: "Register",
		component: Authen
	}, {
		path: "/resetpassword",
		name: "ResetPassword",
		component: Authen
	}, {
		path: "/myaccount",
		name: "MyAccount",
		component: MyAccount
	}
];
routes = routes.concat(routes_user);

const routes_store = [
	{
		path: "/stores",
		name: "StoreList",
		component: StoreList,
	}, {
		path: "/stores/s/:id",
		name: "StoreView",
		component: StoreView,
		props: true,
		alias: "/store/s/:id",  // backwards compatibility
	}
];
routes = routes.concat(routes_store);

const routes_mystore = [
	{
		path: '/mystore/createstore',
		name: "CreateStore",
		component: CreateStore,
		beforeEnter: (to, from, next) => {
			const { userInfo, storeInfo } = user.restore();
			if (storeInfo) return next({ path: '/mystore' });
			if (userInfo) return next();
			next({ path: '/login' });
		}
	}, {
		path: "/mystore",
		component: Store,
		children: [
			{
				path: '',
				alias: 'store',
				name: "MyStore",
				component: MyStore
			}, {
				path: 'product',
				component: ProductManagement,
				beforeEnter: (to, from, next) => {
					const storeInfo = user.restore().storeInfo;
					if (storeInfo.status.valid) return next();
					next({ path: '/mystore' });
				},
			}
		],
		beforeEnter: (to, from, next) => {
			const { userInfo, storeInfo } = user.restore();
			if (storeInfo) return next();
			if (userInfo) return next({ path: '/mystore/createstore' });
			next({ path: '/login' });
		},
	},
	//  {
	// 	path: '/sell',
	// 	name: "CreateProduct",
	// 	component: CreateProduct,
	// 	beforeEnter: (to, from, next) => {
	// 		const storeInfo = user.restore().storeInfo;
	// 		if (storeInfo) return next();
	// 		return next({ path: '/mystore/createstore' });
	// 	},
];
routes = routes.concat(routes_mystore);

const routes_product = [
	{
		name: "animalsProductView",
		path: '/animals/p/:id',
		component: ProductView,
		props: true,
	}, {
		path: '/animals/:p1?/:p2?/:p3?',
		component: ProductsList,
	}, {
		name: "petfoodsProductView",
		path: '/petfoods/p/:id',
		component: ProductView,
		props: true
	}, {
		path: '/petfoods/:p1?/:p2?',
		component: ProductsList
	}, {
		name: "suppliesProductView",
		path: '/supplies/p/:id',
		component: ProductView,
		props: true
	}, {
		path: '/supplies/:p1?/:p2?',
		component: ProductsList
	}, 
];
routes = routes.concat(routes_product);

const routes_admin = [
	{
		path: '/admin',
		component: Admin,
		children: [
			{
				path: '',
				component: AdminHome
			}, {
				path: 'approval',
				component: AdminApproval
			}, {
				path: 'usermanager',
				component: AdminUserManager
			}, {
				path: 'websetting',
				component: AdminWebSetting
			}, {
				path: 'logs',
				component: AdminLogs
			}
		],
		beforeEnter: (to, from, next) => {
			const userInfo = user.restore().userInfo;
			if (userInfo && userInfo.type == 'admin') return next();
			return next({ path: '/' });
		}
	}
];
routes = routes.concat(routes_admin);

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes: routes,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition)
		  	return savedPosition;
		return { x: 0, y: 0 };
	}
});

export default router;